module.exports = __webpack_public_path__ + "static/4_2_nearest-neighbor_RO-9d95406f78e0050faad87fdc0a69f56e.svg";